(function () {
  'use strict';

  var OTHER_HANDLE = '__other__';

  // Runtime config lives in assets/compatible-parts-config.js (loaded just
  // before this file). Anything it doesn't set keeps the default below, so the
  // table still renders if that file is missing.
  var CFG = (function () {
    var defaults = {
      showUncategorized:  true,
      uncategorizedLabel: 'Other',
      uncategorizedOrder: Infinity
    };
    var user = window.CP_CONFIG || {};
    var key;
    for (key in defaults) {
      if (Object.prototype.hasOwnProperty.call(defaults, key) && user[key] !== undefined) {
        defaults[key] = user[key];
      }
    }
    return defaults;
  })();

  function resizeImg(src, width) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + width + 'x$1$2');
  }

  var FETCH_LIMIT = 250;

  function fetchPage(url, cb) {
    fetch(url)
      .then(function (r) {
        if (r.status === 401 || r.redirected) {
          cb(new Error('store_password'), null);
          return;
        }
        if (!r.ok) {
          cb(new Error('HTTP ' + r.status), null);
          return;
        }
        return r.json().then(function (json) {
          if (!json.products) {
            cb(new Error('unexpected_response'), null);
            return;
          }
          cb(null, json.products);
        });
      })
      .catch(function (err) {
        console.error('[Compatible Parts]', err);
        cb(err, null);
      });
  }

  function fetchAll(handle, page, acc, cb) {
    var url = '/collections/' + handle + '/products.json?limit=' + FETCH_LIMIT + '&page=' + page;
    fetchPage(url, function (err, products) {
      if (err) { cb(err, null); return; }
      var all = acc.concat(products);
      if (products.length === FETCH_LIMIT) {
        fetchAll(handle, page + 1, all, cb);
      } else {
        cb(null, all);
      }
    });
  }

  // Placement (handle -> category handle) comes from a paginated Liquid endpoint
  // (templates/collection.parts-data.liquid) so it isn't capped at ~50 products.
  function fetchPlacementPage(handle, page, cb) {
    fetch('/collections/' + handle + '?view=parts-data&page=' + page)
      .then(function (r) {
        if (r.status === 401 || r.redirected) { cb(new Error('store_password'), null); return; }
        if (!r.ok) { cb(new Error('HTTP ' + r.status), null); return; }
        return r.text().then(function (txt) {
          var json;
          try { json = JSON.parse(txt); }
          catch (e) { cb(new Error('placement_parse'), null); return; }
          cb(null, json);
        });
      })
      .catch(function (err) { cb(err, null); });
  }

  function fetchPlacement(handle, page, acc, cb) {
    fetchPlacementPage(handle, page, function (err, data) {
      if (err) { cb(err, acc); return; }
      var parts = data.parts || {};
      Object.keys(parts).forEach(function (k) { acc.cat[k] = parts[k]; });
      var meta = data.meta || {};
      Object.keys(meta).forEach(function (k) { acc.meta[k] = meta[k]; });
      // Display order. `order` is the collection's own product order (manual sort
      // included); fall back to the key order of `parts` so a stale cached copy of
      // the endpoint still produces something sane.
      var order = data.order || Object.keys(parts);
      order.forEach(function (k) {
        if (acc.pos[k] === undefined) acc.pos[k] = acc.posNext++;
      });
      if (data.page < data.pages) {
        fetchPlacement(handle, page + 1, acc, cb);
      } else {
        cb(null, acc);
      }
    });
  }

  function money(amount, currency) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(parseFloat(amount));
  }

  function esc(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var QUALITY = {
    OEM:         { glyph: 'S', tip: 'Stock Part',                          cls: 'oem' },
    RECOMMENDED: { glyph: 'th', tip: "Highly Recommended by Tony's Hobbies", cls: 'recommended' }
  };

  // custom.part_quality is a LIST metafield, so its value can arrive as an array
  // (e.g. ["RECOMMENDED"]). Normalize to a single scalar string.
  function qualityValue(meta) {
    var q = meta && meta.q;
    if (Array.isArray(q)) q = q[0];
    return q || '';
  }

  function badgesHtml(meta) {
    var def = QUALITY[qualityValue(meta)];
    // Empty spacer keeps the thumbnail/name columns aligned across rows.
    if (!def) return '<span class="ra-badge ra-badge--empty" aria-hidden="true"></span>';
    return '<span class="ra-badge ra-badge--' + def.cls + '" aria-label="' + esc(def.tip) + '">'
         + def.glyph
         + '<span class="ra-badge__tip" role="tooltip">' + esc(def.tip) + '</span>'
         + '</span>';
  }

  // Tree guide-line gutter for a node at depth = guides.length.
  // guides[k] = "the ancestor at depth k has siblings after it, keep its trunk
  // line running". The ancestor at depth k+1 owns gutter column k, so column j
  // (0 <= j < d-1) draws a full-height pass-through line iff guides[j+1]; the
  // depth-0 ancestor has no column (top-level rows carry no incoming line).
  // The last column is this node's own connector: a "└" (line stops at 50%)
  // when it is the last sibling, a "├" (full height) otherwise, plus the
  // horizontal tick over to the toggle/dot. mode 'pass' (header rows) draws a
  // plain full-height line in the own column instead — product rows always
  // follow below a header.
  // COL: horizontal indent per nesting level. CTR: shifts every line to the
  // center of the 18px toggle square (and the dot slot) instead of its left
  // edge, so trunks drop straight down from the middle of the +/− glyph.
  var COL = 16;
  var CTR = 9;

  function gutterHtml(guides, mode, isLast) {
    var d = guides.length;
    if (!d) return '';
    var html = '<span class="ra-gutter" style="width:' + (d * COL) + 'px" aria-hidden="true">';
    var j;
    for (j = 0; j + 1 < d; j++) {
      if (guides[j + 1]) html += '<i class="ra-line ra-line--full" style="left:' + (j * COL + CTR) + 'px"></i>';
    }
    var x = (d - 1) * COL + CTR;
    if (mode === 'pass') {
      html += '<i class="ra-line ra-line--full" style="left:' + x + 'px"></i>';
    } else {
      html += '<i class="ra-line ' + (isLast ? 'ra-line--half' : 'ra-line--full') + '" style="left:' + x + 'px"></i>'
            + '<i class="ra-tick" style="left:' + x + 'px"></i>';
    }
    return html + '</span>';
  }

  // "Part / Price" column header — rendered once above a category's own
  // product rows (only when it has direct product children). The left cell is a
  // breadcrumb trail of the owning category's full path (root › … › here); it
  // falls back to a plain "Part" label if the trail is somehow empty.
  function headerRowHtml(guides, trail) {
    var crumbs = '';
    (trail || []).forEach(function (label, i) {
      if (i) crumbs += '<span class="ra-crumb__sep" aria-hidden="true">&rsaquo;</span>';
      crumbs += '<span class="ra-crumb' + (i === trail.length - 1 ? ' ra-crumb--here' : '') + '">' + esc(label) + '</span>';
    });
    return '<div class="ra-phead">'
         + gutterHtml(guides, 'pass', false)
         + '<span class="ra-phead__body">'
         + '<span class="ra-phead__part">' + (crumbs || 'Part') + '</span>'
         + '<span class="ra-phead__price">Price</span>'
         + '<span class="ra-phead__spacer"></span>'
         + '</span></div>';
  }

  function buildRow(p, cartUrl, currency, guides, isLast) {
    var variant   = p.variants && p.variants[0];
    var variantId = variant ? variant.id : null;
    var sku       = variant ? (variant.sku || '') : '';
    var price     = variant ? money(variant.price, currency) : '';
    var available = variant ? variant.available : false;
    var img       = p.images && p.images[0];
    var imgSmall  = img ? resizeImg(img.src, 100) : '';
    var imgLarge  = img ? resizeImg(img.src, 1000) : '';
    var imgAlt    = img ? esc(img.alt || p.title) : '';
    var url       = '/products/' + p.handle;

    var html = '<div class="ra-prow" data-title="' + esc(p.title.toLowerCase()) + '">';
    html += gutterHtml(guides, 'elbow', isLast);
    html += '<span class="ra-prow__body">';

    // Leaf dot (same horizontal slot as the accordion toggle)
    html += '<span class="ra-dot-slot"><span class="ra-dot"></span></span>';

    // Quality badge (S = Stock, th = Tony's Recommends) or an alignment spacer
    html += badgesHtml(p.__meta);

    // Thumbnail (striped placeholder when the product has no image)
    if (imgSmall) {
      html += '<img class="ra-thumb" src="' + imgSmall + '"'
            + ' data-lightbox-src="' + imgLarge + '"'
            + ' data-lightbox-title="' + esc(p.title) + '"'
            + ' alt="' + imgAlt + '" width="36" height="36" loading="lazy">';
    } else {
      html += '<span class="ra-thumb ra-thumb--ph"></span>';
    }

    // Name + SKU stack
    html += '<span class="ra-prow__info">'
          + '<a href="' + url + '" target="_blank" rel="noopener" class="ra-prow__name">' + esc(p.title) + '</a>';
    if (sku) html += '<span class="ra-prow__sku">' + esc(sku) + '</span>';
    html += '</span>';

    html += '<span class="ra-prow__price">' + price + '</span>';

    html += '<span class="ra-prow__action">';
    if (available && variantId) {
      html += '<form action="' + esc(cartUrl) + '" method="post">'
            + '<input type="hidden" name="id" value="' + esc(String(variantId)) + '">'
            + '<input type="hidden" name="quantity" value="1">'
            + '<button type="submit" class="ra-cart-btn">Add to Cart</button>'
            + '</form>';
    } else {
      html += '<span class="ra-soldout">Sold out</span>';
    }
    html += '</span></span></div>';
    return html;
  }

  // Turn the flat category list + placement map + fetched products into a tree
  // of nodes: { handle, label, sortKey, children: [], parts: [] }.
  function buildTree(products, categories, placement) {
    var byHandle = {};
    (categories || []).forEach(function (c) {
      if (!c || !c.handle) return;
      var rawSortKey = c.sort_num;
      // Accept the old payload shapes while cached theme assets roll over.
      if (rawSortKey === undefined) rawSortKey = c.sort_key;
      if (rawSortKey === undefined) rawSortKey = c.order;
      byHandle[c.handle] = {
        handle: c.handle,
        label: c.label || c.handle,
        sortKey: rawSortKey === undefined || rawSortKey === null || rawSortKey === ''
          ? null
          : String(rawSortKey),
        children: [],
        parts: []
      };
    });

    // Link children to parents; blank/unknown parent => root.
    var roots = [];
    (categories || []).forEach(function (c) {
      if (!c || !c.handle) return;
      var node   = byHandle[c.handle];
      var parent = c.parent && byHandle[c.parent];
      if (parent && parent !== node) parent.children.push(node);
      else roots.push(node);
    });

    // Place each product into its category node. Missing/unknown category =>
    // the catch-all group, which CP_CONFIG.showUncategorized can switch off.
    var other = {
      handle:   OTHER_HANDLE,
      label:    CFG.uncategorizedLabel,
      sortKey:  CFG.uncategorizedOrder,
      children: [],
      parts:    []
    };
    var orphans = 0;
    products.forEach(function (p) {
      var handle = placement && placement.cat && placement.cat[p.handle];
      var node   = handle && byHandle[handle];
      if (node) {
        node.parts.push(p);
      } else {
        orphans++;
        if (CFG.showUncategorized) other.parts.push(p);
      }
    });
    if (orphans) {
      console.info('[Compatible Parts] ' + orphans + ' part(s) have no category node; '
        + (CFG.showUncategorized
            ? 'showing them under "' + CFG.uncategorizedLabel + '".'
            : 'hidden (CP_CONFIG.showUncategorized is false).'));
    }
    if (other.parts.length) roots.push(other);

    sortNodes(roots);
    return roots;
  }

  // Position of a part in the collection's own product order, stamped from the
  // placement endpoint. Infinity for anything the endpoint didn't list (only
  // happens if the placement fetch failed), which parks those parts at the end
  // in the order products.json returned them.
  function positionOf(p) {
    return typeof p.__pos === 'number' ? p.__pos : Infinity;
  }

  function sortNodes(nodes) {
    nodes.sort(function (a, b) {
      var ka = a.sortKey, kb = b.sortKey;
      // Infinity is the default key for the synthetic "Other" category.
      if (ka === Infinity || kb === Infinity) {
        if (ka !== kb) return ka === Infinity ? 1 : -1;
      }
      if (ka !== null && kb !== null) {
        // sort_num is an integer metafield, so numeric compare is the normal
        // path; localeCompare only kicks in for legacy non-numeric keys.
        var na = Number(ka), nb = Number(kb);
        var keyOrder = (isFinite(na) && isFinite(nb))
          ? na - nb
          : String(ka).localeCompare(String(kb), undefined, {
              numeric: true,
              sensitivity: 'base'
            });
        if (keyOrder) return keyOrder;
      } else if (ka !== null) {
        return -1;
      } else if (kb !== null) {
        return 1;
      }
      return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
    });
    nodes.forEach(function (n) {
      // Within a category: the collection's own product order, so dragging parts
      // around in the Shopify collection editor is what reorders the table.
      // Nothing else — quality/badges in particular — participates. Ties keep the
      // order they arrived in from fetchAll(), relying on Array#sort being stable,
      // which all supported browsers guarantee.
      n.parts.sort(function (a, b) {
        var pa = positionOf(a), pb = positionOf(b);
        return pa === pb ? 0 : pa - pb;
      });
      sortNodes(n.children);
    });
  }

  // Total parts in a node's whole subtree — used to prune empty branches.
  function subtreeCount(node, seen) {
    seen = seen || [];
    if (seen.indexOf(node) !== -1) return 0; // cycle guard
    seen.push(node);
    var count = node.parts.length;
    node.children.forEach(function (c) { count += subtreeCount(c, seen); });
    return count;
  }

  function renderNode(node, cartUrl, currency, guides, isLast, trail, seen) {
    trail = trail || [];
    seen = seen || [];
    if (seen.indexOf(node) !== -1) return ''; // cycle guard
    seen = seen.concat([node]);

    var total = subtreeCount(node);
    if (!total) return ''; // prune empty branches

    var depth  = guides.length;
    var safeId = 'ra-grp-' + node.handle.replace(/[^a-z0-9]+/gi, '-') + '-' + Math.random().toString(36).slice(2, 7);

    // Sub-categories and this node's own parts are one sibling list for the
    // guide lines: "last child" means last across both.
    var kids = node.children.filter(function (c) { return subtreeCount(c) > 0; });
    var childGuides = guides.concat([!isLast]);
    var childTrail  = trail.concat([node.label]);

    var inner = '';
    kids.forEach(function (c, i) {
      var lastKid = (i === kids.length - 1) && !node.parts.length;
      inner += renderNode(c, cartUrl, currency, childGuides, lastKid, childTrail, seen);
    });
    if (node.parts.length) {
      inner += headerRowHtml(childGuides, childTrail);
      node.parts.forEach(function (p, i) {
        inner += buildRow(p, cartUrl, currency, childGuides, i === node.parts.length - 1);
      });
    }

    // Every category starts collapsed, including top-level ones.
    var open   = false;
    var dclass = Math.min(depth, 2);

    return '<div class="ra-node" data-group="' + esc(node.handle) + '">'
         + '<button type="button" class="ra-arow ra-arow--d' + dclass + '" data-ra-toggle'
         + ' aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="' + safeId + '">'
         + gutterHtml(guides, 'elbow', isLast)
         + '<span class="ra-arow__body">'
         + '<span class="ra-toggle" aria-hidden="true"></span>'
         + '<span class="ra-arow__name">' + esc(node.label) + '</span>'
         + '<span class="ra-arow__count">(' + total + ')</span>'
         + '</span></button>'
         + '<div id="' + safeId + '" class="ra-wrap' + (open ? ' ra-wrap--open' : '') + '">'
         + '<div class="ra-wrap__inner">' + inner + '</div>'
         + '</div></div>';
  }

  function buildTable(products, cartUrl, currency, categories, placement) {
    placement = placement || { cat: {}, meta: {}, pos: {} };
    products.forEach(function (p) {
      p.__meta = (placement.meta && placement.meta[p.handle]) || null;
      p.__pos  = (placement.pos && placement.pos[p.handle]);
    });
    var roots = buildTree(products, categories, placement).filter(function (n) {
      return subtreeCount(n) > 0;
    });
    // Everything can still be filtered out here — e.g. every part is
    // uncategorized and showUncategorized is off. Signal that with '' so the
    // caller shows the empty message instead of a blank tree.
    if (!roots.length) return '';
    var html = '';
    roots.forEach(function (node, i) {
      html += renderNode(node, cartUrl, currency, [], i === roots.length - 1);
    });
    return '<div class="ra-tree">' + html + '</div>';
  }

  function setExpanded(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) {
      if (open) panel.classList.add('ra-wrap--open');
      else panel.classList.remove('ra-wrap--open');
    }
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function wireCollapsibles(container) {
    container.querySelectorAll('[data-ra-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setExpanded(this, this.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function wireSearch(searchId, noResultsId, container) {
    var input     = document.getElementById(searchId);
    var noResults = document.getElementById(noResultsId);
    if (!input) return;
    input.addEventListener('input', function () {
      var q      = this.value.toLowerCase().trim();
      var groups = container.querySelectorAll('[data-group]');
      var total  = 0;
      groups.forEach(function (g) {
        var rows    = g.querySelectorAll('.ra-prow');
        var visible = 0;
        rows.forEach(function (r) {
          var show = q === '' || (r.getAttribute('data-title') || '').indexOf(q) !== -1;
          r.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        g.style.display = (q === '' || visible > 0) ? '' : 'none';
        if (q !== '' && visible > 0) {
          var btn = g.querySelector('[data-ra-toggle]');
          if (btn) setExpanded(btn, true);
        }
        total += visible;
      });
      if (noResults) noResults.style.display = total === 0 && q !== '' ? 'block' : 'none';
    });
  }

  function initLoader(el) {
    var handle      = el.getAttribute('data-collection-handle');
    var cartUrl     = el.getAttribute('data-cart-url') || '/cart/add';
    var currency    = el.getAttribute('data-currency') || 'USD';
    var searchId    = el.getAttribute('data-search-id');
    var noResId     = el.getAttribute('data-no-results-id');
    var dataId      = el.getAttribute('data-cp-data');
    if (!handle) return;

    var categories = [];
    try {
      var dataEl = dataId && document.getElementById(dataId);
      if (dataEl) {
        var parsed = JSON.parse(dataEl.textContent);
        categories = parsed.categories || [];
      }
    } catch (e) { console.warn('[Compatible Parts] Could not parse category data', e); }

    // Fetch the full placement map (all pages), then the product data, then render.
    fetchPlacement(handle, 1, { cat: {}, meta: {}, pos: {}, posNext: 0 }, function (perr, placement) {
      if (perr) { console.warn('[Compatible Parts] Placement fetch failed; parts will fall back to "Other"', perr); }
      fetchAll(handle, 1, [], function (err, products) {
        if (err) {
          var msg = err.message === 'store_password'
            ? 'The store password is blocking this request. Disable the password under Online Store → Preferences, or access the store while logged in to Shopify admin.'
            : 'Could not load compatible parts (' + err.message + '). Check the browser console for details.';
          el.innerHTML = '<div class="card__section"><p>' + msg + '</p></div>';
          return;
        }
        if (!products.length) {
          el.innerHTML = '<div class="card__section"><p>No compatible parts found in this collection.</p></div>';
          return;
        }
        var table = buildTable(products, cartUrl, currency, categories, placement || { cat: {}, meta: {}, pos: {} });
        if (!table) {
          el.innerHTML = '<div class="card__section"><p>No compatible parts found in this collection.</p></div>';
          return;
        }
        el.innerHTML = table;
        wireCollapsibles(el);
        if (window.CPLightbox) window.CPLightbox.init(el);
        wireSearch(searchId, noResId, el);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cp-loader]').forEach(initLoader);
  });
})();
